import injector from 'vue-inject'

class Money {
    constructor() {
        this.decimals = {
            fto: 8,
            fnd: 2
        };
    }

    isInteger(amount) {
        return Number.isInteger(amount) || !isNaN(parseInt(amount));
    }

    /**
     * Format money
     * @param amount
     * @param currency
     * @returns {string}
     */
    format(amount, currency) {
        return this.isInteger(amount) ? (parseInt(amount) / Math.pow(10, this.decimals[currency])).toFixed(this.decimals[currency]) : '-';
    }

    /**
     * Format money
     * @param amount
     * @param currency
     * @returns {*}
     */
    unformat(amount, currency) {
        return !isNaN(amount) ? parseInt(parseFloat(amount) * Math.pow(10, this.decimals[currency])) : '-';
    }

    /**
     * Typical values are passed as a cents equivalent but packages are defined as a dollars
     * Convert dollars to cents then parse
     * @param packet
     * @param currency
     */
    packageFormat(packet, currency) {
        return this.format(packet * 100, currency);
    }
}

injector.service('money', Money);



// WEBPACK FOOTER //
// ./src/services/money.js